module.exports = __webpack_public_path__ + "static/media/Panda.06ad690e.png";